import axios from 'axios';

const initialState = {
  loadedRecording: null,
  error: null,
  email: {
    data: null,
    error: null,
    isLoading: false,
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    isDialerEmailValid(state) {
      return state.email.data && state.email.data.valid;
    }
  },
  mutations: {
    // Re-initializes the state
    resetState(state) {
      Object.keys(initialState).forEach(field => {
        state[field] = initialState[field];
      });
    },
    loadRecording(state, recording) {
      state.loadedRecording = recording;
    },
    setDialerError(state, error) {
      state.error = error;
    },
    setDialerEmailData(state, data) {
      state.email.data = data;
    },
    setDialerEmailIsLoading(state, loading) {
      state.email.isLoading = loading;
    },
    setDialerEmailError(state, error) {
      state.email.error = error
    },
  },
  actions: {
    async getRecording({ commit }, { recordingId }) {
      try {
        const response = await axios({
          url: `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/dialer/recordings/${recordingId}`,
          method: 'GET',
          responseType: 'blob',
          timeout: 30000,
        });
        const blobUrl = URL.createObjectURL(response.data);
        commit('loadRecording', { recordingId, blobUrl });
      } catch (err) {
        commit('setDialerError', err);
      }
    },
    async saveRecording({ commit, dispatch }, { contactId, recordingId }) {
      try {
        await axios({
          url: `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/dialer/recordings`,
          method: 'POST',
          data: { id: recordingId },
        });
      } catch (err) {
        commit('setDialerError', err);
      }
      dispatch(
        'eventList/getEvents',
        { allWebTypes: true, contactId, pagination: { page: 1, sortBy: 'created_at', descending: true } },
        { root: true },
      );
    },
    async verifyEmailDialer({ commit }, token) {
      commit('setDialerEmailIsLoading', true);
      try {
        const { data } = await axios({
          url: `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/dialer/email/verify`,
          method: 'POST',
          params: {
            token,
          }
        });

        commit('setDialerEmailData', { email: data.email, valid: true});
      } catch (error) {
        if (error.data && error.data.error) {
          commit('setDialerEmailError', error.data.error);
        } else {
          commit('setDialerEmailError', error);
        }
      } finally {
        commit('setDialerEmailIsLoading', false);
      }
    },
    clearDialerEmailError({ commit}) {
      commit('setDialerEmailError', null);
    },
    async getEmailDialer({ commit }) {
      commit('setDialerEmailIsLoading', true);
      try {
        const { data } = await axios({
          url: `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/dialer/email`,
          method: 'GET',
        });

        commit('setDialerEmailData', data);
      } catch (error) {
        if (error.data && error.data.error) {
          commit('setDialerEmailError', error.data.error);
        } else {
          commit('setDialerEmailError', error);
        }
      } finally {
        commit('setDialerEmailIsLoading', false);
      }
    },
    async registerEmailDialer({ commit }, email) {
      commit('setDialerEmailIsLoading', true);
      try {
        await axios({
          url: `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/dialer/email`,
          method: 'POST',
          data: {
            email,
          }
        });
      } catch (error) {
        if (error.data && error.data && error.data.errors && error.data.errors.length) {
          commit('setDialerEmailError', error.data.errors[0].message);
        } else if (error.data && error.data.error) {
          commit('setDialerEmailError', error.data.error);
        } else {
          commit('setDialerEmailError', error);
        }
      } finally {
        commit('setDialerEmailIsLoading', false);
      }
    },
  },
};
